import { ProdState } from "./types";

const jsVolume = document.querySelectorAll<HTMLElement>(`.jsVolume`);
jsVolume.forEach((item) => {
	item.onclick = () => {
		videoPlayer.toggleVolume();
	};
});

const getProgressBarClickInfo = (progress_bar: HTMLElement, e: any) => {
	const x = e.pageX - progress_bar.offsetLeft;
	const y = e.pageY - progress_bar.offsetTop;
	const max = parseInt(progress_bar.dataset.max || "");
	const value = (x * max) / progress_bar.offsetWidth;
	return {
		x: x,
		y: y,
		max: max,
		value: value,
	};
};
interface Props {
	productId: number;
	videoId: number;
	videoNode: HTMLVideoElement | null;
	progressbar: HTMLElement | null;
	onChange: () => void;
	onCanplay: () => void;
	onPlay: () => void;
	onPause: () => void;
	onEnded: () => void;
	onWaiting: () => void;
	next: () => void;
}
type Dom = {
	videoNode: HTMLVideoElement | null;
	progressbar: HTMLElement | null;
	list: null;
};
class VideoPlayer {
	dom: Dom;
	props: Props;
	state: {};
	constructor() {
		this.dom = {
			videoNode: null,
			progressbar: null,
			list: null,
		};
		this.props = {
			productId: 0,
			videoId: 0,
			videoNode: null,
			progressbar: null,
			onChange: () => {},
			onCanplay: () => {},
			onPlay: () => {},
			onPause: () => {},
			onEnded: () => {},
			onWaiting: () => {},
			next: () => {},
		};
		this.state = {};
	}

	unmount() {
		if (this.dom.videoNode) {
			this.pause();
		}
	}
	mount(props: Props) {
		this.unmount();
		this.dom.videoNode = props.videoNode;
		
		this.props.productId = props.productId;
		this.props.videoId = props.videoId;
		if (this.dom.videoNode !== null) {
			this.dom.videoNode.oncanplay = () => {
				props.onCanplay();
				this.dom.videoNode?.play();
			};
			this.dom.videoNode.onplay = () => {
				props.onPlay();
			};
			this.dom.videoNode.onpause = () => {
				props.onPause();
			};

			this.dom.videoNode.onwaiting = () => {
				props.onWaiting();
			};
			this.dom.videoNode.onended = () => {
				props.onEnded();
			};
			this.dom.videoNode.onerror = () => {
				if (this.dom.videoNode?.error?.code === 4) {
					console.log("error");
					props.next();
				}
            };
            if (props.progressbar) {
                this.setControlsNodes(props.progressbar);
            }
		}
	}
	setControlsNodes(progressbar: HTMLElement) {
		if (this.dom.videoNode) {
			// console.log("setControlsNodes", progressbar);
			this.dom.progressbar = progressbar;
			this.dom.videoNode.addEventListener(
				"timeupdate",
				() => {
					if (this.dom.progressbar) {
						const line = this.dom.progressbar.querySelector<HTMLElement>(
							".line"
						);
						if (line && this.dom.videoNode) {
							line.style.width = `${(
								(this.dom.videoNode.currentTime * 100) /
								this.dom.videoNode.duration
							).toFixed()}%`;
						}
					}
				},
				false
			);

			progressbar.onclick = (event: any) => {
				const info = getProgressBarClickInfo(progressbar, event);
				if (this.dom.videoNode) {
					const value =
						(this.dom.videoNode.duration / info.max) * info.value;
					this.dom.videoNode.currentTime = parseFloat(value + "");
				}
			};
		}
	}

	toggleVolume() {
		// alert("jsVolume toggleVolume")
		// if (videoPlayer.dom.audio.volume > 0) {
		// 	videoPlayer.dom.audio.volume = 0;
		// 	jsVolume.forEach((item) => item.classList.add("off"));
		// } else {
		// 	videoPlayer.dom.audio.volume = 0.5;
		// 	jsVolume.forEach((item) => item.classList.remove("off"));
		// }
	}
	play() {
		this.dom.videoNode?.play();
		this.onChange();
	}
	togglePlay() {
		// console.log("togglePlay" , videoPlayer.dom.videoNode?.paused)
		this.dom.videoNode?.paused ? this.play() : this.pause();
		this.onChange();
	}
	pause() {
		this.dom.videoNode?.pause();
	}
	onChange() {
		// videoPlayer?.props?.onChange();
	}
}
const videoPlayer = new VideoPlayer();
// videoPlayer.init();
(<any>window).videoPlayer = videoPlayer;
export default videoPlayer;
//  END videoPlayer;
